/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Pos_Barcode_AddedInputs */

const vi_pos_barcode_added = /** @type {(inputs: Pos_Barcode_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã thêm ${i?.name}`)
};

/**

* @param {Pos_Barcode_AddedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_barcode_added = /** @type {((inputs: Pos_Barcode_AddedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Barcode_AddedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_barcode_added(inputs)
});